import { render, staticRenderFns } from "./tingkatRisiko.vue?vue&type=template&id=5959a1d2&"
import script from "./tingkatRisiko.vue?vue&type=script&lang=js&"
export * from "./tingkatRisiko.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports